import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Box, Button, Paper, TextField, Typography } from '@mui/material';
import axios from 'axios';
import apiBase from '../../lib/apiBase';

export default function PasswordReset({ complete = false }) {
    const [token] = useState(() => new URLSearchParams(window.location.hash.slice(1)).get('token') || '');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmation, setConfirmation] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const submit = async event => {
        event.preventDefault();
        setError('');
        if (complete && password !== confirmation) { setError('Passwords do not match.'); return; }
        setBusy(true);
        try {
            const response = await axios.post(`${apiBase}/auth/${complete ? 'reset-password' : 'forgot-password'}`, complete ? { token, password } : { email }, { withCredentials: true });
            setMessage(response.data.message);
            if (complete) window.history.replaceState(null, '', window.location.pathname);
        } catch (e) { setError(e.response?.data?.message || 'Unable to complete the request. Please try again.'); }
        finally { setBusy(false); }
    };
    return <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2, bgcolor: '#f5f7fa' }}>
        <Paper component="form" onSubmit={submit} sx={{ p: 4, width: '100%', maxWidth: 440 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>{complete ? 'Choose a new password' : 'Reset your password'}</Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>{complete ? 'Use at least 12 characters.' : 'Enter your account email to receive a reset link.'}</Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
            {message ? <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert> : <>
                {complete ? <>
                    <TextField fullWidth required type="password" label="New password" autoComplete="new-password" inputProps={{ minLength: 12 }} value={password} onChange={e => setPassword(e.target.value)} sx={{ mb: 2 }} />
                    <TextField fullWidth required type="password" label="Confirm password" autoComplete="new-password" value={confirmation} onChange={e => setConfirmation(e.target.value)} sx={{ mb: 2 }} />
                </> : <TextField fullWidth required type="email" label="Email address" autoComplete="email" value={email} onChange={e => setEmail(e.target.value)} sx={{ mb: 2 }} />}
                <Button fullWidth type="submit" variant="contained" disabled={busy || (complete && !token)}>{busy ? 'Please wait…' : complete ? 'Save password' : 'Send reset link'}</Button>
                {complete && !token && <Alert severity="warning" sx={{ mt: 2 }}>This link is missing its reset token. <Link to="/forgot-password">Request a new link</Link>.</Alert>}
            </>}
            <Button component={Link} to="/" fullWidth sx={{ mt: 2 }}>Back to sign in</Button>
        </Paper>
    </Box>;
}
